// @flow

import * as React from 'react';
import Box from 'sail/Box';
import type {PaneState} from '../helpers/react/reducer';
import {ApiExplorer} from '../../ApiExplorer/ApiExplorer';

type Props = {
  panes: Array<PaneState>,
  renderPane: (PaneState, number) => React.Node,
  showApiExplorer: boolean,
};

const StripeCluiTerminalContent = ({
  panes,
  renderPane,
  showApiExplorer,
}: Props): React.Node => {
  const gridTemplateColumns = showApiExplorer
    ? `700px repeat(${panes.length}, minmax(0, 100%))`
    : `repeat(${panes.length}, minmax(0, 100%))`;
  return (
    <div
      className="StripeCluiTerminalContent"
      style={{
        display: 'grid',
        gridTemplateColumns: `${gridTemplateColumns}`,
        gridTemplateRows: 'repeat(1, 100%)',
      }}
    >
      {showApiExplorer && (
        <Box padding={24} style={{overflowY: 'auto'}}>
          <ApiExplorer embedded />
        </Box>
      )}
      {panes.map((pane, paneIdx) => (
        <React.Fragment key={pane.paneID}>
          {renderPane(pane, paneIdx)}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StripeCluiTerminalContent;
